import React from 'react';
import { ICONIFY } from '../../../../../Constants/iconify';
import CommonNode from '../../shared/CommonNode';
import NodeWrapper from '../../shared/NodeWrapper';

function TextFieldNode({ data }) {
    return (
        <NodeWrapper nodeId={data?.id}>
            <CommonNode data={data} icon={ICONIFY.TEXT_FIELD} />
        </NodeWrapper>
    );
}

export default React.memo(TextFieldNode)
